import React, { lazy } from 'react';

const LazyRider = lazy(() => import('./Rider'));

const Rider = (props) => <LazyRider {...props} />;

export default Rider;
